import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbars from "./Components/navbar";
import Homelink from "./Home/homelink";
import Servicelink from './Services/servicelink';
import Portfoliolink from './Portfolio/portfoliolink';
import Aboutlink from './About/aboutlink';
import Contactlink from "./Contact/contactlink";
import Projectlink from "./Startproject/projectlink";
import Detailslink from "./Startproject/detailslink";
import Timelinelink from "./Startproject/timelinelink";
import ScrollToTop from "./Components/scrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbars />

      <Routes>
        <Route path="/" element={<Homelink />} />
        <Route path="/services" element={<Servicelink />} />
        <Route path="/portfolio" element={<Portfoliolink />} />
        <Route path="/about" element={<Aboutlink />} />
        <Route path="/contact" element={<Contactlink />} />
        <Route path="/start-project" element={<Projectlink />} />
        <Route path="/project" element={<Detailslink />} />
        <Route path="/timeline" element={<Timelinelink />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;